import { ReactNode, useEffect } from "react";
import { AnimateProps, useSharedValue, useAnimatedStyle, withRepeat, withTiming, cancelAnimation, Easing } from "react-native-reanimated";

import { Box, BoxProps } from "@kolmeo/ui-core";
import { createAnimatedComponent } from "./helpers";

const AnimatedBox = createAnimatedComponent(Box);



type RotateAnimationProps = {
  children: ReactNode;
  rotationDuration?: number;
  reverse?: boolean;
} & AnimateProps<BoxProps>;

const RotateAnimation = ({
  children,
  rotationDuration = 1400,
  reverse = false,
  ...props
}: RotateAnimationProps) => {

  const rotation = useSharedValue(0);

  const animatedStyles = useAnimatedStyle(() => {
    return {
      transform: [
        {
          rotateZ: `${rotation.value}deg`,
        },
        {
          translateY: 0,
        },
      ],
    };
  }, [rotation.value]);

  useEffect(() => {
    rotation.value = withRepeat(
      withTiming(360, {
        duration: rotationDuration,
        easing: Easing.linear,
      }),
      -1
    );
    return () => cancelAnimation(rotation);
  }, []);
  return (
    <AnimatedBox
    style={[animatedStyles]}
    {...props}
    >
      {children}
    </AnimatedBox>
  );
};

export default RotateAnimation;